import { create } from "zustand";

export interface IRouteFeatureMarkersActions {
    setOpen: (open: boolean) => void;
    toggleOpen: () => void;
}

export interface IRouteFeatureMarkersState {
    actions: IRouteFeatureMarkersActions;
    open: boolean;
}

const useRouteFeatureMarkersStore = create<IRouteFeatureMarkersState>( (set) => ({
    open: false,
    actions: {
        setOpen: (open: boolean) => {
            set({open: open});
        },
        toggleOpen: () => {
            set((state) => ({open: !state.open}));
        }
    }
}));

export const useRouteFeatureMarkersState = () => useRouteFeatureMarkersStore((state) => state.open);
export const useRouteFeatureMarkersActions = () => useRouteFeatureMarkersStore((state) => state.actions);